/**
 * IMPORTS
 */

import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleCriarCamposVariaveis } from "@/domain/use-cases/modelos";

type ICreateCamposVariaveisModeloResponse = {
  code: number;
  status: string;
  message: string;
  data: {
    id: number;
    modelo_tecnico_id: number;
    nome: string;
    obrigatorio: boolean;
    updated_at: string;
    created_at: string;
  };
};

type ICampoVariavel = {
  modelo_tecnico_id: number;
  nome: string;
  obrigatorio: boolean;
  ordem: number;
};

type ICreateModeloPayload = {
  campos: ICampoVariavel[];
};

const notifySuccess = (message: string) =>
  toast(message, {
    type: "success",
    position: "top-center",
  });

const notifyError = (message: string) =>
  toast(message, {
    type: "error",
    position: "top-center",
  });

export function useCriarCamposVariaveisModelo() {
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<ICreateCamposVariaveisModeloResponse, Error, ICreateModeloPayload>({
    mutationFn: async (payload) => {
      return await handleCriarCamposVariaveis(token!, payload);
    },
    onSuccess: async () => {
      notifySuccess("Campo variáveis adicionado ao modelo com sucesso!");
    },
    onError: async () => {
      notifyError("Error ao criar campos variáveis para o modelo");
    },
  });

  return {
    criarCamposVariaveisModelo: mutation.mutate, // chamada direta
    criarCamposVariaveisModeloAsync: mutation.mutateAsync, // se quiser await
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
